/**
 * @description В общем случае возвращает объект-образ (обычно компонент) в зависимости от значения
 * указанного во втором аргументе поля объекта-источника помогает в маппинге каких-либо сущностей
 * использовать соответствующие компоненты (или иные образы) сущностей
 * @param  object объект-источник
 * @param  key  поле, по значению которого будет выбран объект
 * @param  cases объект, ставящий в соответствие значению поля объект-образ (компонент)
 */
export const matchByField = <
  TObject extends { [s: string]: any },
  TKey extends keyof TObject,
  TCases extends {
    [TKeyValue in NonNullable<TObject>[TKey]]: (value: Extract<TObject, { [_ in TKey]: TKeyValue }>) => any
  },
>(
  object: TObject | null,
  key: TKey,
  cases: TCases,
): ReturnType<TCases[keyof TCases]> | null => {
  if (object !== null) {
    const value = object[key]

    if (value in cases) {
      // @ts-expect-error
      return cases[value](object)
    }
  }

  return null
}
